import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import finger from './../../img/tutorial/finger@3x.png';
import yes from './../../img/tutorial/yes@3x.png';
import no from './../../img/tutorial/no@3x.png';


class TutorialStep4 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step4)}>
        <div className={classnames(baseStyles.tutorial_subtitle, baseStyles.centered)}>
          Plagiarism is a breach of academic honesty. <br />
          It is <span className={baseStyles.text_extradanger}>NOT</span> tolerated according to our policies and leads to a <span className={baseStyles.text_extradanger}>FAILED</span> assignment.
        </div>

        <i className={baseStyles.tutorial_devider} />

        <h3>Types:</h3>

        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_6)}>
            <div className={baseStyles.border_block}>
              <h6 className={classnames(baseStyles.tutorial_subtitle, baseStyles.text_extradanger)}>Direct Plagiarism</h6>
              <p>25% of the paper is a copied section of someone else’s work with no credit to a source.</p>
            </div>
          </div>

          <div className={grid.col_6}>
            <div className={baseStyles.border_block}>
              <h6 className={classnames(baseStyles.tutorial_subtitle, baseStyles.text_extradanger)}>Self Plagiarism</h6>
              <p>Copy-pasted excerpts from previous papers.</p>
            </div>
          </div>
        </div>

        <div className={classnames(grid.row, baseStyles.mb_50)}>
          <div className={classnames(grid.col_6)}>
            <div className={baseStyles.border_block}>
              <h6 className={classnames(baseStyles.tutorial_subtitle, baseStyles.text_extradanger)}>Mosaic Plagiarism</h6>
              <p>Direct quotes comprise 15% of the required word count.</p>
            </div>
          </div>

          <div className={grid.col_6}>
            <div className={baseStyles.border_block}>
              <h6 className={classnames(baseStyles.tutorial_subtitle, baseStyles.text_extradanger)}>Accidental Plagiarism</h6>
              <p>Missing citations, fake references.</p>
            </div>
          </div>
        </div>

        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_6, baseStyles.centered)}>
            <img src={no} alt="no" height="111px" />
            <h2 className={baseStyles.tutorial_title_sm}>Don’ts</h2>


            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__danger, baseStyles.mb_0)}>
              <li>Do not include restated phrases without <br/> citing a source;</li>
              <li>Do not use the copied sections of <br/> someone else’s work;</li>
              <li>Do not use any excerpts from your <br/> previous papers;</li>
              <li>Do not misquote the incorporated <br/> information.</li>
            </ul>
          </div>

          <div className={classnames(grid.col_6, baseStyles.centered)}>
            <img src={yes} alt="yes" height="111px" />
            <h2 className={baseStyles.tutorial_title_sm}>Do’s</h2>

            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__succes, baseStyles.mb_0)}>
              <li><b>ALWAYS</b> give credit to a source that <br/> you use;</li>
              <li>Use no more than 10% of direct <br/> quotes;</li>
              <li>Interpret outside information in your <br/> own words;</li>
              <li>Use and cite only <b>REAL</b> sources.</li>
            </ul>
          </div>
        </div>

        <div className={classnames(baseStyles.content_danger, baseStyles.mb_30)}>
          <span className={classnames(baseStyles.ribbon_flag, baseStyles.danger)}>
            EXAMPLE
          </span>
          <p>
            <b className={baseStyles.block}>In-text citation according to the MLA fomat requirements:</b>
            After the 9/11 attacks the administration limited “law enforcement access to gun- related data” <b>(Spitzer 111)</b>.
          </p>
          <p>
            <b className={baseStyles.block}>Reference in MLA:</b>
            <i className={baseStyles.block}>Spitzer, Robert J. Politics of gun control.</i>
            Routledge, 2015.
          </p>
        </div>

        <div className={baseStyles.remember_block}>
          <img src={finger} alt="finger" width="54px" />
          <h3>REMEMBER</h3>
          <p>All sources cited in the body of the paper should also be presented in the Works Cited/ Reference page</p>
        </div>

      </div>
    )
  }
}

export default TutorialStep4;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep4.js